// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"4edb804088dd86c37215","966":"7ce43ca87887b5bb218c"}[chunkId] + ".js";
};